import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Form, Input, Image, Alert } from 'antd';

const CAPTCHA_STYLES = {
  errorBorder: '#ff4d4f',
  errorShadow: '0 0 0 2px rgba(255, 77, 79, 0.2)',
  normalBorder: '#d9d9d9',
  captchaImage: { width: 150, height: 48, borderRadius: 4, cursor: 'pointer', userSelect: 'none' },
  inputStyle: { minWidth: 260, flex: 1 }
};

const CaptchaModal = React.memo(({ visible, imageUrl, onCancel, onConfirm, loading, onRefresh, error, onChange }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!visible) setValue('');
  }, [visible]);

  const handleInputChange = useCallback((e) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange?.(newValue);
  }, [onChange]);

  const handleRefresh = useCallback(() => {
    onRefresh?.();
  }, [onRefresh]);

  const handleErrorClose = useCallback(() => {
    onChange?.('');
  }, [onChange]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={() => onConfirm(value)}
      okButtonProps={{ loading, disabled: !value }}
      okText="确认"
      cancelText="取消"
      title="请通过图片验证来继续操作"
      destroyOnClose
      maskClosable={false}
      width={520}
    >
      {error && (
        <Alert
          message="验证码错误"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          closable
          onClose={handleErrorClose}
        />
      )}
      <Form layout="horizontal" labelAlign="right" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
        <Form.Item label="验证码" validateStatus={error ? 'error' : undefined}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <Input
              size="large"
              placeholder="请输入图片中的字符"
              value={value}
              onChange={handleInputChange}
              onPressEnter={() => value && onConfirm(value)}
              autoFocus
              style={{ 
                ...CAPTCHA_STYLES.inputStyle,
                borderColor: error ? CAPTCHA_STYLES.errorBorder : undefined,
                boxShadow: error ? CAPTCHA_STYLES.errorShadow : undefined
              }}
            />
            {imageUrl && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Image
                  src={imageUrl}
                  alt="验证码图片，点击可刷新"
                  preview={false}
                  onClick={handleRefresh}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleRefresh();
                    }
                  }}
                  style={{ 
                    ...CAPTCHA_STYLES.captchaImage,
                    border: error 
                      ? `2px solid ${CAPTCHA_STYLES.errorBorder}` 
                      : `1px solid ${CAPTCHA_STYLES.normalBorder}`
                  }}
                />
                <a 
                  onClick={handleRefresh}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleRefresh();
                    }
                  }}
                  style={{ 
                    marginTop: 6, 
                    color: error ? CAPTCHA_STYLES.errorBorder : undefined 
                  }}
                  role="button"
                  tabIndex={0}
                >
                  看不清？换一张
                </a>
              </div>
            )}
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
});

CaptchaModal.displayName = 'CaptchaModal';

export default CaptchaModal;
